module.exports = __webpack_public_path__ + "static/poleemploi-502972c80b76efbc304974e0b3dc270a.png";